import primary_bg from "../assets/images/gray_map.png";
import att_text from "../assets/images/att_text.png";
import app_store_link from "../assets/images/app_store_link.svg";
import play_store_link from "../assets/images/play_store_link.png";

import att_logo from "../assets/images/att_logo_only_black.png";
import around_me from "../assets/images/around_me.png";
import splash from "../assets/images/splash.png";

import upload from "../assets/images/upload.png";

import preview_1 from "../assets/images/iPhone preview/1.png";
import preview_2 from "../assets/images/iPhone preview/2.png";  
import preview_3 from "../assets/images/iPhone preview/3.png";
import preview_4 from "../assets/images/iPhone preview/4.png";
import preview_5 from "../assets/images/iPhone preview/5.png";

import eng_preview_1 from "../assets/images/iPhone preview English/1.png";
import eng_preview_2 from "../assets/images/iPhone preview English/2.png";
import eng_preview_3 from "../assets/images/iPhone preview English/3.png";
import eng_preview_4 from "../assets/images/iPhone preview English/4.png";
import eng_preview_5 from "../assets/images/iPhone preview English/5.png";

import att_app_logo from "../assets/images/att_app_logo.png";

const images = { primary_bg, att_text, app_store_link, play_store_link, att_logo, around_me, splash, upload,
    preview_1, preview_2, preview_3, preview_4, preview_5,
    eng_preview_1, eng_preview_2, eng_preview_3, eng_preview_4, eng_preview_5,
    att_app_logo
};

export default images;
